import { PfeTile } from 'widgets/signalTiles/pfeTile/components/PfeTile';
import { pfeTileDescription } from 'widgets/signalTiles/pfeTile/components/description/pfeTileDescription';
import {
    buildSignalTileWidgetStrategy,
    SignalTileWidgetStrategyOptions,
} from 'widgets/signalTiles/signalTile/SignalTileWidgetStrategy';
import { WidgetType } from 'widgets/WidgetType';
import {
    pfeConfigSlice,
    pfeStreamedDataSelectors,
} from 'widgets/signalTiles/pfeTile/state';
import { PfeTileMyPortfolioCapsuleContent } from 'widgets/signalTiles/pfeTile/components/PfeTileMyPortfolioCapsuleContent';

const { useStreamedDataMessages } = pfeStreamedDataSelectors;

const options: SignalTileWidgetStrategyOptions = {
    title: 'PFE',
    reactComponentType: PfeTile,
    description: pfeTileDescription,
    widgetType: WidgetType.PFE_TILE,
    startChannelDestination: 'startPfeStream',
    configSlice: pfeConfigSlice,
    myPortfolioCapsuleContentReactComponentType:
        PfeTileMyPortfolioCapsuleContent,
    useStreamedDataMessages,
};

export const pfeTileWidgetStrategy = buildSignalTileWidgetStrategy(options);
